import { h } from 'vue'
import { notice } from 'complex-plugin'
import { ComplexList, DefaultEdit } from 'complex-data'
import { parseAttributes } from 'complex-component/src/antd/utils'
import { buildDictionaryBySelect } from '@/config/dictionary'
import { listWidth } from '@/config/dictionary/config'
import LayoutParse from '@/config/utils/layout'
import vehicleApi from '@/pages/index/api/vehicle'
import { ApprovalStatus, baseSwitch } from '@/pages/index/select'
import serviceProvider from '../../system/service-provider/mainData'
import parkingPoint from '../../system/parking-point/mainData'
import CostDetail from './components/CostDetail.vue'
import { uploadFile } from '@/pages/index/utils/file'
import { downloadFile, getNum } from 'complex-utils'
import { Button } from 'ant-design-vue'
import { dict } from '@/pages/index/select/dict'
import config from '@/config'

export class PreservationList extends ComplexList {
  buildItem(postData: Record<string, unknown>, payload: { id: string }) {
    return new Promise((resolve, reject) => {
      postData.overdueRecordId = payload.id
      vehicleApi.vehiclePreservationBuild.require(postData).then(() => {
        notice.showMsg('车辆保全申请成功！', 'success')
        resolve({ status: 'success' })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
  changeItem(postData: Record<string, unknown>, payload: { id: string }, originData: Record<string, unknown>, flowKey: string) {
    return new Promise((resolve, reject) => {
      postData.id = originData.id
      postData.taskId = payload.id
      postData.curTaskDefKey = flowKey
      vehicleApi.vehiclePreservationChange.require(postData).then(() => {
        notice.showMsg('车辆保全申请审批成功！', 'success')
        resolve({ status: 'success' })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
  rejectItem(postData: Record<string, unknown>, payload: { id: string }, originData: Record<string, unknown>) {
    return new Promise((resolve, reject) => {
      postData.id = originData.id
      postData.taskId = payload.id
      vehicleApi.vehiclePreservationReject.require(postData).then(() => {
        notice.showMsg('车辆保全申请驳回完成！', 'success')
        resolve({ status: 'success' })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
}

const layoutParse = new LayoutParse(2, 6, 16)
const searchLayoutParse = new LayoutParse(4, 8, 16)

const preservationList = new PreservationList({
  name: '车辆保全申请',
  prop: 'preservationList',
  module: {
    pagination: true,
    search: {
      module: {
        dictionary: {
          layout: {
            default: searchLayoutParse.getData(4)
          },
          list: [
            buildDictionaryBySelect(dict.business_lines_green, {
              prop: 'itemname',
              name: '业务线',
              originProp: 'itemname',
              originFrom: 'local',
              mod: {
                search: {
                  $target: 'edit'
                }
              }
            }, {
              onlyLabel: true
            }),
            {
              prop: 'contractNumber',
              name: '合同号',
              originProp: 'contractNumber',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            {
              prop: 'customerName',
              name: '承租人',
              originProp: 'customerName',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            {
              prop: 'createdName',
              name: '创建人',
              originProp: 'createdName',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            {
              prop: 'vinNo',
              name: '车架号',
              originProp: 'vinNo',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            {
              prop: 'engineNo',
              name: '发动机编号',
              originProp: 'engineNo',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            {
              prop: 'beginCreatedTime',
              name: '创建时间',
              originProp: 'beginCreatedTime',
              originFrom: 'local',
              layout: {
                default: searchLayoutParse.getData(2)
              },
              post(value, { targetData }) {
                if (value) {
                  targetData.endCreatedTime = (value as string[])[1]
                  return (value as string[])[0]
                }
              },
              mod: {
                search: {
                  $type: 'edit',
                  type: 'dateRange',
                  option: {
                    time: {}
                  }
                }
              }
            },
          ]
        }
      },
      menu: {
        list: []
      },
    },
    dictionary: {
      layout: {
        default: layoutParse.getData(2)
      },
      option: {},
      propData: {
        id: 'id'
      },
      list: [
        {
          prop: 'menu',
          name: '操作',
          originProp: 'menu',
          originFrom: 'local',
          mod: {
            list: {
              width: listWidth.getWidth(2),
              local: {
                fixed: 'left'
              },
            }
          }
        },
        {
          prop: 'id',
          name: 'ID',
          originProp: 'id',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'input',
              disabled: true,
              observe(this: DefaultEdit, target, prop, val, from) {
                if (from === 'init') {
                  target.hidden(this.prop)
                }
              },
            },
            ufo_cs_bq_20: {
              $target: 'edit'
            },
            ufo_cs_bq_50: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'overdueRecordId',
          name: '逾期记录ID',
          originProp: 'overdueRecordId',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'code',
          name: '申请编号',
          originProp: 'code',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.getWidth(0, 11, 2)
            }
          }
        },
        {
          prop: 'contractNumber',
          name: '合同号',
          originProp: 'contractNumber',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.contractNumber
            }
          }
        },
        {
          prop: 'itemname',
          name: '业务线',
          originProp: 'itemname',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.businessLine
            }
          }
        },
        {
          prop: 'customerName',
          name: '承租人',
          originProp: 'customerName',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.personnelName
            }
          }
        },
        {
          prop: 'brandname',
          name: '品牌',
          originProp: 'brandname',
          originFrom: 'list',
          mod: {
            list: {}
          }
        },
        {
          prop: 'vinNo',
          name: '车架号',
          originProp: 'vinNo',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.vin
            }
          }
        },
        {
          prop: 'engineNo',
          name: '发动机编号',
          originProp: 'engineNo',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.vehicleEngineNo
            }
          }
        },
        {
          prop: 'applyUserId',
          name: '申请人ID',
          originProp: 'applyUserId',
          originFrom: 'list',
          mod: {}
        },
        buildDictionaryBySelect(ApprovalStatus, {
          prop: 'applyStatus',
          name: '审批状态',
          originProp: 'applyStatus',
          originFrom: 'list',
          mod: {
            list: {}
          }
        }),
        {
          prop: 'estimatedCost',
          name: '预估费用',
          originProp: 'estimatedCost',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              option: {
                min: 0,
                step: 1,
                precision: 2
              },
              required: true
            },
            ufo_cs_bq_10: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'risk',
          name: '风险说明',
          originProp: 'risk',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'textArea',
              option: {
                min: 0,
                step: 1
              },
              required: true
            },
            ufo_cs_bq_10: {
              $target: 'edit'
            }
          }
        },
        buildDictionaryBySelect(baseSwitch, {
          prop: 'outsourcingFlag',
          name: '是否委外',
          originProp: 'outsourcingFlag',
          originFrom: 'list',
          mod: {
            edit: {
              required: true
            },
            ufo_cs_bq_20: {
              $target: 'edit'
            }
          }
        }),
        {
          prop: 'outsourcingServiceId',
          name: '委外服务商',
          originProp: 'outsourcingServiceId',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'select',
              required: true,
              reload: true,
              observe(target, prop, val, from) {
                if (prop === 'outsourcingFlag') {
                  if (from !== 'init') {
                    target.$data!.outsourcingServiceId = undefined
                  }
                  if (val === '1') {
                    // 线上
                    target.show('outsourcingServiceId')
                  } else {
                    target.hidden('outsourcingServiceId')
                  }
                }
              },
              $getData(this: DefaultEdit<'select'>) {
                return new Promise((resolve, reject) => {
                  serviceProvider.$reloadData({})?.then(() => {
                    this.$option.list = serviceProvider.$select.getList()
                    resolve({ status: 'success' })
                  }).catch(err => {
                    reject(err)
                  })
                })
              }
            },
            ufo_cs_bq_20: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'authFilePath',
          name: '授权书',
          originProp: 'authFilePath',
          originFrom: 'list',
          mod: {
            list: {
              render(payload) {
                if (payload.text) {
                  return h('span', {
                    class: 'local-main-link',
                    onClick() {
                      downloadFile(payload.text)
                    }
                  }, '下载')
                } else {
                  return null
                }
              }
            },
            edit: {
              type: 'button',
              slot: {
                type: 'data',
                render(payload) {
                  const url = payload.form.data.authFilePath
                  return h(Button, {
                    type: 'primary',
                    disabled: !url,
                    onClick() {
                      downloadFile(url)
                    }
                  }, '下载')
                },
              },
              observe(this: DefaultEdit, target, prop, val, from) {
                if (from === 'init' && prop === 'authFilePath') {
                  if (val) {
                    target.show(this.prop)
                  } else {
                    target.hidden(this.prop)
                  }
                }
              },
            },
            ufo_cs_bq_50: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'collectionLetterFilePath',
          name: '收车告知函',
          originProp: 'collectionLetterFilePath',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'button',
              slot: {
                type: 'data',
                render(payload) {
                  const url = payload.form.data.collectionLetterFilePath
                  return h(Button, {
                    type: 'primary',
                    disabled: !url,
                    onClick() {
                      downloadFile(url)
                    }
                  }, '下载')
                },
              },
              observe(this: DefaultEdit, target, prop, val, from) {
                if (from === 'init' && prop === 'collectionLetterFilePath') {
                  if (val) {
                    target.show(this.prop)
                  } else {
                    target.hidden(this.prop)
                  }
                }
              },
            },
            ufo_cs_bq_50: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'detailList',
          name: '费用明细',
          originProp: 'detailList',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(1)
          },
          mod: {
            edit: {
              type: 'select',
              required: true,
              slot: {
                type: 'model',
                render(payload) {
                  const props = parseAttributes(payload.option)
                  return h(CostDetail, {
                    id: payload.form.data.id,
                    ...props
                  } as any)
                }
              },
              observe(this: DefaultEdit, target, prop, val) {
                if (prop === this.prop) {
                  if (val && val.length > 0) {
                    let cost = 0;
                    (val as any[]).forEach(item => {
                      cost += item.cost
                    })
                    target.$data!.actualCost = getNum(cost)
                  } else {
                    target.$data!.actualCost = undefined
                  }
                }
              },
            },
            ufo_cs_bq_50: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'actualCost',
          name: '实际费用',
          originProp: 'actualCost',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              disabled: true,
              option: {
                precision: 2
              }
            },
            ufo_cs_bq_50: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'costDescription',
          name: '费用说明',
          originProp: 'costDescription',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'textArea',
              required: true
            },
            ufo_cs_bq_50: {
              $target: 'edit'
            }
          }
        },
        buildDictionaryBySelect(baseSwitch, {
          prop: 'legalLitigationFlag',
          name: '是否法诉',
          originProp: 'legalLitigationFlag',
          originFrom: 'list',
          mod: {
            edit: {
              required: true
            },
            ufo_cs_bq_50: {
              $target: 'edit'
            }
          }
        }),
        {
          prop: 'parkPointId',
          name: '停车场',
          originProp: 'parkPointId',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'select',
              reload: true,
              required: true,
              $getData(this: DefaultEdit<'select'>) {
                return new Promise((resolve, reject) => {
                  parkingPoint.$reloadData({})?.then(() => {
                    this.$option.list = parkingPoint.$select.getList()
                    resolve({ status: 'success' })
                  }).catch(err => {
                    reject(err)
                  })
                })
              }
            },
            ufo_cs_bq_50: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'collectionMethod',
          name: '无',
          originProp: 'collectionMethod',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'warehousingDate',
          name: '入库时间',
          originProp: 'warehousingDate',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'date',
              required: true
            },
            ufo_cs_bq_50: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'parkPointAddress',
          name: '停车地址',
          originProp: 'parkPointAddress',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'input',
              required: true,
              option: {
                size: 256
              }
            },
            ufo_cs_bq_50: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'remark',
          name: '无',
          originProp: 'remark',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'createdBy',
          name: '无',
          originProp: 'createdBy',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'createdName',
          name: '创建人',
          originProp: 'createdName',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.personnelName
            }
          }
        },
        {
          prop: 'createdTime',
          name: '创建时间',
          originProp: 'createdTime',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.time
            }
          }
        },
        {
          prop: 'fileList',
          name: '附件',
          originProp: 'fileList',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(1)
          },
          post(value) {
            return (value as any[]).map(item => item.data)
          },
          mod: {
            edit: {
              type: 'file',
              multiple: true,
              required: true,
              local: {
                target: {
                  props: {
                    complex: true
                  }
                }
              },
              option: {
                accept: config.file,
                upload (fileList) {
                  return uploadFile(fileList as unknown as File[], 'preservationFile')
                }
              }
            },
            ufo_cs_bq_50: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'updatedBy',
          name: '无',
          originProp: 'updatedBy',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'updatedTime',
          name: '无',
          originProp: 'updatedTime',
          originFrom: 'list',
          mod: {}
        }
      ]
    }
  },
  $getData(this: PreservationList) {
    return new Promise((resolve, reject) => {
      vehicleApi.vehiclePreservation.require({
        ...this.$getSearch(),
        pageNo: this.$getPageData('current')!,
        pageSize: this.$getPageData('size')!
      }).then(res => {
        this.$formatList(res.data.data, res.data.totalCount)
        resolve({ status: 'success' })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
})

export default preservationList
